// extracted by mini-css-extract-plugin
export default {"searchable":"_searchable_QI+khI"};